import React from "react";
import { useForm, Link, usePage } from "@inertiajs/react";
import { Button } from "../../components/ui/button";
import { Mail } from "lucide-react";

interface Props {
  email: string;
}

interface PageProps {
  flash?: {
    notice?: string;
    alert?: string;
  };
  [key: string]: unknown;
}

export default function Required({ email }: Props) {
  const { flash } = usePage<PageProps>().props;
  const { post, processing } = useForm({});

  const handleResend = (e: React.FormEvent) => {
    e.preventDefault();
    post("/email_confirmation");
  };

  return (
    <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <div className="h-16 w-16 rounded-full bg-[#008788]/10 flex items-center justify-center">
            <Mail className="h-8 w-8 text-[#008788]" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
          Confirmez votre email
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Nous avons envoyé un email de confirmation à
        </p>
        <p className="mt-1 text-center text-sm font-semibold text-gray-900">
          {email}
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {flash?.notice && (
            <div className="mb-4 rounded-md bg-green-50 p-4">
              <p className="text-sm text-green-800">{flash.notice}</p>
            </div>
          )}
          {flash?.alert && (
            <div className="mb-4 rounded-md bg-red-50 p-4">
              <p className="text-sm text-red-800">{flash.alert}</p>
            </div>
          )}

          <p className="text-sm text-gray-600 text-center mb-6">
            Cliquez sur le lien dans l'email pour activer votre compte. Pensez à vérifier vos spams si vous ne trouvez pas l'email.
          </p>

          <form onSubmit={handleResend}>
            <Button
              type="submit"
              className="w-full"
              disabled={processing}
            >
              {processing ? "Envoi en cours..." : "Renvoyer l'email de confirmation"}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link
              href="/session"
              method="delete"
              as="button"
              className="text-sm font-medium text-[#008788] hover:text-[#00bcbe]"
            >
              Se déconnecter
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
